import { AppMenuItem } from 'src/types/types';
import { MenuProvider } from 'src/layout/context/menucontext';

import AppMenuitem from './AppMenuitem';
import { useEffect, useState } from 'react';
import { ToastService } from '@iamsoftware/react-hooks';

const AppMenu = () => {

  const getLocalToolPath = () => {
    return '/iam/tool/Iam_EcontractSetup.zip';
  };

  const downloadSignTool = async () => {
    try {
      const downloadSource = getLocalToolPath();
      const fileExt = 'zip';
      const fileName = `Iam_EcontractSetup.${fileExt}`;

      const fileResponse = await fetch(downloadSource, {
        method: 'GET',
        headers: {
          'Accept': 'application/octet-stream'
        }
      });

      if (!fileResponse.ok) {
        throw new Error('Không thể tải file từ máy chủ');
      }

      const blob = await fileResponse.blob();
      const downloadUrl = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = downloadUrl;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(downloadUrl);

      ToastService.success(`Đang tải công cụ ký...`);
    } catch (error) {
      console.error('Lỗi khi tải tool:', error);
      ToastService.error('Có lỗi xảy ra khi tải công cụ ký');
    }
  }
  const appMenus: Array<AppMenuItem> = [
    {
      label: '',
      items: [{ label: 'Tổng quan', icon: 'pi pi-desktop', to: '/dashboard' }]
    },
    {
      label: 'Quản lý tài liệu',
      items: [
        { label: 'Danh sách tài liệu', icon: 'pi pi-fw pi-pencil', to: '/quan-ly-tai-lieu/danh-sach-tai-lieu' },
      ]
    },
    {
      label: 'Cấu hình tài liệu',
      items: [
        { label: 'Loại tài liệu', icon: 'pi pi-fw pi-cog', to: '/quan-ly-loai-tai-lieu' },
        { label: 'Tài liệu mẫu', icon: 'pi pi-fw pi-file-word ', to: '/quan-ly-loai-tai-lieu/tai-lieu-mau' }
      ]
    },
    // {
    //   label: 'Hợp đồng',
    //   items: [
    //     { label: 'Quản lý hợp đồng', icon: 'pi pi-fw pi-file-word', to: '/hop-dong/quan-ly-hop-dong' },
    //     { label: 'Mẫu hợp đồng', icon: 'pi pi-fw pi-file-word', to: '/hop-dong/mau-hop-dong' },
    {
      label: 'Danh mục',
      items: [
        { label: 'Quản lý khách hàng', icon: 'pi pi-fw pi-users', to: '/danh-muc/khach-hang' },
        { label: 'Quản lý vai trò', icon: 'pi pi-fw pi-id-card', to: '/danh-muc/vai-tro' },
      ]
    },
    //     { label: 'Sản phẩm/ Dịch vụ', icon: 'pi pi-fw pi-box', to: '/danh-muc/san-pham' }
    //   ]
    // },
    {
      label: 'Tài khoản',
      items: [
        { label: 'Thông tin tài khoản', icon: 'pi pi-fw pi-id-card', to: '/tai-khoan/thong-tin' },
        { label: 'Chữ ký của tôi', icon: 'pi pi-fw pi-pencil', to: '/tai-khoan/chu-ky' }
      ]
    },

    {
      label: 'Hệ thống',
      items: [
        { label: 'Lịch sử gửi mail', icon: 'pi pi-fw pi-envelope', to: '/he-thong/lich-su-gui-mail' },
        { label: 'Tải công cụ ký', icon: 'pi pi-fw pi-desktop', command: downloadSignTool }
      ]
    },
  ];

  const pluck = menu => {
    if (menu.items?.length) {
      if (typeof menu.visible !== 'boolean') {
        menu.items.forEach(item => pluck(item));
        menu.visible = menu.items.filter(item => item.visible !== false).length > 0;
      }
    }
  }
  appMenus.forEach(appMenu => {
    pluck(appMenu);
  });


  return (
    <MenuProvider>
      <ul className="layout-menu">
        {appMenus.map((item, i) => {
          return !item?.seperator ? <AppMenuitem item={item} root={true} index={i} key={i} /> : <li className="menu-separator"></li>;
        })}
      </ul>
    </MenuProvider>
  );
}

export default AppMenu;